import { render, staticRenderFns } from "./usersTabs.vue?vue&type=template&id=fd39c46c"
import script from "./usersTabs.vue?vue&type=script&lang=js"
export * from "./usersTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports